import { render } from "./MdlNuevaPartidaEntrada.vue?vue&type=template&id=60cfa816"
import script from "./MdlNuevaPartidaEntrada.vue?vue&type=script&lang=js"
export * from "./MdlNuevaPartidaEntrada.vue?vue&type=script&lang=js"

import "./MdlNuevaPartidaEntrada.vue?vue&type=style&index=0&id=60cfa816&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__